<template>
    <emc-card-stats
        color="blue darken-4"
        icon="mdi-school-outline"
        icon-large
        :value="this.grids"
        title="A contratar"
        sub-text="Número de disciplinas a contratar"
        >
        <template v-slot:actions>
            <emc-button-icon btn-small :loading="loading" icon="mdi-refresh-circle" :text="updated_at || `Atualizar`" color="success" @click.prevent.stop="refresh()" />
        </template>
        </emc-card-stats>
</template>

<script>

import { mapActions } from 'vuex'

export default {
    name: 'EmcChartGridInHiringNumber',
    data () {
        return {
            grids: '0',
            title: '',
            updated_at: null,
            loading: false,
            attempts: 1
        }
    },
    methods: {
        ...mapActions('chart', ['ActionChartGridInHiringNumber', 'ActionGridInHiringNumbersRefresh']),
        async getData() {
            await this.ActionChartGridInHiringNumber()
                .then((r) => {
                    this.grids = r.data.value
                    this.title = r.data.title
                    this.updated_at = r.data.updated_at
                })
        },
        refresh() {
            this.loading = true

            this.ActionGridInHiringNumbersRefresh()
                .then(() => {
                    this.getDataRefresh()
                })
        },
        getDataRefresh()
        {
            let number = this.grids;

            setTimeout(async () => {

                    await this.getData()
                    
                    if(number != this.grids || this.attempts == 3) {
                        this.loading = false
                    } else {
                        this.attempts++
                        this.getDataRefresh()
                    }

            }, 5000)
        }
    },
    created(){
        this.getData()
    }

    
}
</script>